(ns scittle.eql
  {:no-doc true}
  (:require [scittle.core :as scittle]
            [sci.core :as sci]
    [edn-query-language.core]))

;; Plugin: eql
;; Generated by build.clj

(defn init []
  (scittle/register-plugin!
   ::eql
   {:namespaces
   {'edn-query-language.core (sci/copy-ns edn-query-language.core (sci/create-ns 'edn-query-language.core nil))}}
   ))
